import { useParams } from "react-router-dom";
import { SearchX } from "lucide-react";

import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/empty-state";
import { DetailSkeleton } from "@/components/loading-skeletons";
import { PageHeader } from "@/components/layout/page-header";
import { DataSourceForm } from "@/components/data-source/data-source-form";
import { useDataSourceQuery } from "@/hooks/use-data-sources";

const BREADCRUMBS = [
  { label: "Widgets", to: "/widgets" },
  { label: "Data Sources", to: "/widgets/data-sources" },
];

export function EditDataSourcePage() {
  const { id } = useParams<{ id: string }>();
  const { data: dataSource, isLoading, error, refetch } = useDataSourceQuery(id!);

  if (isLoading) {
    return (
      <div className="flex flex-1 flex-col gap-6">
        <PageHeader breadcrumbs={BREADCRUMBS} title="Edit Data Source" />
        <DetailSkeleton withTitle={false} />
      </div>
    );
  }

  if (error || !dataSource) {
    return (
      <div className="flex flex-1 flex-col gap-6">
        <PageHeader breadcrumbs={BREADCRUMBS} title="Edit Data Source" />
        <EmptyState
          icon={SearchX}
          title="Data Source Not Found"
          description="The data source you are looking for does not exist."
        >
          <Button variant="outline" size="sm" onClick={() => refetch()}>
            Retry
          </Button>
        </EmptyState>
      </div>
    );
  }

  return <DataSourceForm mode="edit" dataSource={dataSource} />;
}
